import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { AlternateStudentAvailability } from './alternate-student-availability';
export { AlternateStudentAvailability };
import { alternateStudentAvailabilitySchema } from '@schemas/business-objects/alternate-student-availability';
import { AlternateStudentFormGroup } from './alternate-student-form-group';
import { SlotFormGroup } from './slot-form-group';

export class AlternateStudentAvailabilityFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    slotId: SchemaFormControl;
    slot: SlotFormGroup;
    alternateStudentId: SchemaFormControl;
    alternateStudent: AlternateStudentFormGroup;
  };

  declare value: Partial<AlternateStudentAvailability>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      alternateStudentAvailabilitySchema,
      AlternateStudentAvailability,
      data,
      options,
    );
  }

  get object(): AlternateStudentAvailability {
    return new AlternateStudentAvailability(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'slot':
        return new SlotFormGroup();
      case 'alternateStudent':
        return new AlternateStudentFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<AlternateStudentAvailability[]> {
    return AlternateStudentAvailability.find(filter);
  }

  static async findOne(
    filter?: any,
  ): Promise<AlternateStudentAvailability | null> {
    return AlternateStudentAvailability.findOne(filter);
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<AlternateStudentAvailability> {
    return AlternateStudentAvailability.findById(id, filter);
  }

  static async create(
    data: Partial<AlternateStudentAvailability>,
  ): Promise<AlternateStudentAvailability> {
    return AlternateStudentAvailability.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<AlternateStudentAvailability>,
  ): Promise<AlternateStudentAvailability> {
    return AlternateStudentAvailability.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return AlternateStudentAvailability.deleteById(id);
  }
}

export class AlternateStudentAvailabilityFormArray extends PersistedFormArray {
  readonly entityName = 'AlternateStudentAvailability' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(
      alternateStudentAvailabilitySchema,
      AlternateStudentAvailability,
      options,
    );
  }

  protected override createItemGroup() {
    return new AlternateStudentAvailabilityFormGroup();
  }

  get array(): AlternateStudentAvailability[] {
    return this.controls.map(
      (group: AlternateStudentAvailabilityFormGroup) => group.object,
    );
  }
}

export class AlternateStudentAvailabilityPersistedArray extends PersistedArray<AlternateStudentAvailability> {
  readonly entityName = 'AlternateStudentAvailability' as const;

  constructor(options?: PersistedArrayOptions) {
    super(AlternateStudentAvailability, options);
  }
}
